import { NotificationService } from '@cradua/core';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { map, catchError, concatMap, exhaustMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as ProgressMasterActions from './progress-master.actions';
import { ProgressMasterService } from '../../services/progress-master.service';
import { Router } from '@angular/router';

@Injectable()
export class ProgressMasterEffects {
  loadProgressMaster$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProgressMasterActions.loadProgressMaster),
      exhaustMap((_) =>
        this.progressMasterService.getProgressMaster().pipe(
          map((data) =>
            ProgressMasterActions.loadProgressMasterSuccess({
              progressMaster: data,
            })
          ),
          catchError((error) => {
            if (error.statusText === 'Unknown Error') {
              this.notification.error(
                'Unable to get response from server, please try again'
              );
            }

            return of(
              ProgressMasterActions.loadProgressMasterFailure({
                error,
              })
            );
          })
        )
      )
    )
  );

  addProgressMaster$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProgressMasterActions.addProgressMaster),
      concatMap(({ newProgressMaster }) =>
        this.progressMasterService.createProgressMaster(newProgressMaster).pipe(
          map((data) => {
            this.notification.success('Saved Successfully');
            return ProgressMasterActions.addProgressMasterSuccess({
              newProgressMaster: data,
            });
          }),
          catchError((error) => {
            console.log('error ', error);

            return of(
              ProgressMasterActions.addProgressMasterFailure({
                error: error.error.message,
              })
            );
          })
        )
      )
    )
  );

  // addSuccess$ = createEffect(
  // 	() =>
  // 		this.actions$.pipe(
  // 			ofType(ProgressMasterActions.addProgressMasterSuccess),
  // 			tap(() => {
  // 				return this.router.navigate([ '/project' ]);
  // 			})
  // 		),
  // 	{ dispatch: false }
  // );

  updateProgressMaster$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProgressMasterActions.updateProgressMaster),
      concatMap(({ updateProgressMaster }) =>
        this.progressMasterService
          .updateProgressMaster(updateProgressMaster)
          .pipe(
            map((data) => {
              // console.log('update effect data ', data);
              this.notification.success('Updated Successfully');
              return ProgressMasterActions.updateProgressMasterSuccess({
                updateProgressMaster: data,
              });
            }),
            catchError((error) => {
              return of(
                ProgressMasterActions.updateProgressMasterFailure({
                  error: error.message,
                })
              );
            })
          )
      )
    )
  );

  updateSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ProgressMasterActions.updateProgressMasterSuccess),
        tap(() => {
          console.log('navigate');
          return this.router.navigate(['/project']);
        })
      ),
    { dispatch: false }
  );

  removeProgressMaster$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProgressMasterActions.removeProgressMaster),
      map((action) => action.ids),
      concatMap((ids) =>
        this.progressMasterService.deleteProgressMaster(ids).pipe(
          map(() => {
            this.notification.success('Deleted Successfully');
            return ProgressMasterActions.removeProgressMasterSuccess({ ids });
          }),
          catchError((error) =>
            of(
              ProgressMasterActions.updateProgressMasterFailure({
                error: error.message,
              })
            )
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private progressMasterService: ProgressMasterService,
    private notification: NotificationService,
    private router: Router
  ) {}
}
